module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-details ma-0"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('h1', {
    staticClass: "display-1 pr-3 mr-3"
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('h2', {
    staticClass: "body-2"
  }, [_c('span', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('span', [_vm._v(".")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0aa23023","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/NotFound.vue
// module id = 387
// module chunks = 0